var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from 'axios';
// Same public identifiers as AuthContext / msalConfig (not secrets).
const CLIENT_ID = '4e427b72-05a2-4186-a728-d6369e408a01';
const TENANT_ID = '30f52344-4663-4c2e-bab3-61bf24ebbed8';
const TOKEN_URL = `https://login.microsoftonline.com/${TENANT_ID}/oauth2/v2.0/token`;
const EXPIRY_SKEW_SECONDS = 60;
const CALLBACK_PATH = '/.auth/login/aad/callback';
/** True while the OAuth redirect is being completed (Callback exchanges the code). */
export const isOnAuthCallback = () => window.location.pathname.startsWith(CALLBACK_PATH);
// Older builds could store the literal strings "undefined"/"null" as the refresh token.
const getStoredRefreshToken = () => {
    const value = localStorage.getItem('refresh_token');
    return value && value !== 'undefined' && value !== 'null' ? value : null;
};
/** Drops unusable tokens (so the next page load does not retry them) and asks for a new login. */
const signalAuthRequired = () => {
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    window.dispatchEvent(new Event('auth:required'));
};
export const getStoredAccessToken = () => localStorage.getItem('access_token');
const isExpired = (token) => {
    try {
        const payload = JSON.parse(atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')));
        return payload.exp * 1000 - EXPIRY_SKEW_SECONDS * 1000 < Date.now();
    }
    catch (_a) {
        return true;
    }
};
let refreshInFlight = null;
/** Exchanges the stored refresh token for a new access token. Returns null on failure. */
export const refreshAccessToken = () => {
    // The callback page is exchanging the login code; refreshing or re-login here would race it.
    if (isOnAuthCallback())
        return Promise.resolve(null);
    if (refreshInFlight)
        return refreshInFlight;
    const refreshToken = getStoredRefreshToken();
    if (!refreshToken) {
        signalAuthRequired();
        return Promise.resolve(null);
    }
    const params = new URLSearchParams();
    params.append('client_id', CLIENT_ID);
    params.append('grant_type', 'refresh_token');
    params.append('refresh_token', refreshToken);
    refreshInFlight = axios
        .post(TOKEN_URL, params.toString(), {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    })
        .then((response) => {
        const { access_token: accessToken, refresh_token: newRefreshToken } = response.data;
        if (typeof accessToken !== 'string' || !accessToken) {
            throw new Error('Refresh response did not contain an access token');
        }
        localStorage.setItem('access_token', accessToken);
        if (newRefreshToken)
            localStorage.setItem('refresh_token', newRefreshToken);
        return accessToken;
    })
        .catch(() => {
        signalAuthRequired();
        return null;
    })
        .finally(() => {
        refreshInFlight = null;
    });
    return refreshInFlight;
};
/** Returns a non-expired access token, refreshing if needed; null if none can be obtained. */
export const getValidAccessToken = () => __awaiter(void 0, void 0, void 0, function* () {
    const token = getStoredAccessToken();
    if (token && !isExpired(token))
        return token;
    return refreshAccessToken();
});
